"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('setIsFullOptionsShown', function setIsFullOptionsShown(newValue) {
    store_1.getStore().isFullOptionsShown = newValue;
});
//# sourceMappingURL=setIsFullOptionsShown.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/mutators/setIsFullOptionsShown.js
// module id = 3722
// module chunks = 2